export const skinCustom = {
  lightComponents: {
    body: '#ECEFF1',
    gradient: {
      gradientDefault1: '#c49b38',
      gradientDefault2: '#004e99',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: 'http://rvcsolucoes.com.br/image-bank/logo_rvc-branca.png',
  favicon: '/cadeadosd.png',
}

export const seo = {
  titulo: 'Rvc Consultoria Especializada LTDA',
  email: 'suporte@senhadigital.com.br',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado curitiba',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: false,
  contaLogin: true,
}

export const contentHome = {
  sispass: true,
  produtorRural: true,
  modalidadesCertificado: true,
  ratingGoogle: false,
}

export const footer = {
  is0800: false,
  telefone: '',
  whatsapp: '',
  botaoRenocao: '',
  comercial: '4195227449',
  marketing: '',
  botaoWhatsapp: '41995227449',
  number0800: '0800 600 2710',
  cidadeuf: 'Campo Mourão/PR',
  cidade: 'Campo Mourão',
  bairro: 'Centro',
  titulo: 'Certificado Digital em Campo Mourão',
  rua: 'RUA SANTOS DUMONT',
  numero: '1165',
  complemento: 'SALA B',
  cep: '87300480',
  cnpj: '64.742.910/0001-22',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador.',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento: 'Olá, gostaria de agendar a emissão do meu Certificado',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes:
    'Olá, gostaria de conhecer as soluções da Senha Digital',
}

export const redes = {
  facebook: 'https://www.facebook.com/senhadigitaloficial/',
  instagram: 'https://www.instagram.com/senhadigital/',
  linkedin: 'https://www.linkedin.com/company/senhadigitaloficial/mycompany/',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: true,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
